// extracted by mini-css-extract-plugin
module.exports = {"noResults":"CompanyReviews_noResults__3hJDz CompanyRatings_noResults__37xip"};